import template from './trip-traveller-allocation-flight.html';

const DIRECTIVE_NAME = TripTravellerAllocationFlight.DIRECTIVE_NAME = 'ktTripTravellerAllocationFlight';
export default function TripTravellerAllocationFlight() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripTravellerAllocationFlightController,
        controllerAs: '$ctrl',
        scope: {
            flight: `=${DIRECTIVE_NAME}`,
            group: `=${DIRECTIVE_NAME}Group`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
            selectedSeats: `=${DIRECTIVE_NAME}SelectedSeats`,
            isExpanded: `=${DIRECTIVE_NAME}IsExpanded`,
            isLast: `=${DIRECTIVE_NAME}IsLast`,
            recommendation: `=${DIRECTIVE_NAME}Recommendation`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TripTravellerAllocationFlightController(
    userService,
    $scope,
    tripTravellerAllocationFlightService,
    moment,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        isDepartureInformationVisible,
        isConnectionAirportVisible,
        moment,
    });

    function $onInit() {
        initTravellersWatcher();
        initDepartureInformationVisibility();
        vm.rs = userService.getRegionalSettings();
    }

    function initTravellersWatcher() {
        $scope.$watch(() => vm.tripDetails.Travelers, () => {
            vm.travellers = tripTravellerAllocationFlightService.getTravellersWhichAreAllowedToSelectSeat(vm.tripDetails);
        });
    }

    function initDepartureInformationVisibility() {
        vm.flightingGroupHasStops = vm.group
            && vm.group.FlightStops
            && vm.group.FlightStops.length > 0;
    }

    function isConnectionAirportVisible() {
        return vm.isExpanded
            && !vm.isLast;
    }

    function isDepartureInformationVisible() {
        return vm.flightingGroupHasStops
            && vm.isExpanded;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-segment/trip-traveller-allocation-flight/trip-traveller-allocation-flight-component.js